const firebaseConfig = {
  apiKey: "AIzaSyDaR-KYChndjdq72ajqVApfekNGMjfRUDc",
  authDomain: "mqmexico-7c834.firebaseapp.com",
  projectId: "mqmexico-7c834",
  storageBucket: "mqmexico-7c834.firebasestorage.app",
  messagingSenderId: "1010457339958",
  appId: "1:1010457339958:web:2ea6e38dd339d903329097",
  measurementId: "G-V07BLTYCSS",
};

import { getMessaging, getToken, onMessage } from "firebase/messaging";

import StartUpMainApp from "../modules/main-start-up-screen/start-up";
import iconCamara from "../../Icons/icons-charcoal-dark/camara.png";

import { v4 as uuidv4 } from "uuid";

// Import required Firebase modules
import { initializeApp } from "firebase/app";
import {
  collection,
  collectionGroup,
  getCountFromServer,
  getFirestore,
  doc,
  addDoc,
  deleteDoc,
  setDoc,
  Timestamp,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
  limit,
  startAfter,
  startAt,
  endAt,
  writeBatch,
  arrayUnion,
  updateDoc,
  increment,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, uploadBytesResumable, getDownloadURL } from "firebase/storage";


import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  sendEmailVerification,
  signOut,
  updateProfile,
  sendPasswordResetEmail,
} from "firebase/auth";

import { getFunctions, httpsCallable } from "firebase/functions";

import { getDatabase, ref as dbRTRef, get } from "firebase/database";

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const functions = getFunctions(firebaseApp);

const storage = getStorage(firebaseApp); // ✅ for Storage
const db = getFirestore(firebaseApp); // ✅ for Firestore
const dbRT = getDatabase(firebaseApp); // ✅ Realtime DB (pass the app)
const messaging = getMessaging(firebaseApp); // ✅ for messaging

// const swRegistration = await navigator.serviceWorker.ready;


const VAPIDKEY = 'BHe5dIT3RZJOk5aeZ33IB7JxM5dZ56Pkt-xLRg1zRwFLBoNJ6FEzdzg4nlBFiIcM_mzmLMU4wmc14oBJHO2_Yg8'




import ngeohash from "ngeohash";
import { geohashQueryBounds, distanceBetween } from "geofire-common";


import GENRALHELPERS from "./GENRAL-HELPERS";
import spinner from "./spinner";
import inAppNotification from "./in-app-notification";
import { title } from "process";
import createListing from "./create-listing/create-listing";
import NVBusinessEditor from "./business-page-editor/NV-business-editor";
import CTANotifications from "./CTANotifications";

const omittedWordsInTokens = ["año", "de", "a", "del", "venta", "compra"];

class FireBaseHelperOwn {
  #targetedSearchLastDoc;
  #currentAuthUserID = null;
  #currentAuthUserData = null;
  #liveListenerForAccount = false;
  #notificationOnWalletChange = false;
  #notificationOnWalletChangeTitle = "";
  #notificationOnWalletChangeBody = "";
  #notificationOnWalletChangeButtonLabel = "";
  #notificationOnWalletChangeButtonAction = "";

  #userDataLiveListenerUnsubscribe = null


  #timesCalledAgain = 0;
  #wasSignedIn = false;

  constructor() {
    // this._NVSearchTest()

    // this._authenticateListerner();


    // THIS is the funtion that initializes this page
    // this._authStateHandlerOnceAndOnChange();}



    // this._syncDataToItems();
    // this._requestPayPalOrder({ amount: "12688.93" });
    // this._onSnapShotForWallet("ygTqsX1DPwE2rQCLhLec");

    // this._signInUser("benklassen19@icloud.com", "Be123456");

    // setTimeout(() => {
    //   this._signInUser("thorastrack@gmail.com", "Be123456");
    //   setTimeout(() => {
    //     this._signOutUser();
    //   }, 4000);
    // }, 8000);

    // this._authenticateNewUser("benklasse19@icloud.com", "Be123456", "Ben");
    // this._updateUserTemplate(dataForTemplate);
    // this._uploadMachineData(machines);
    // this._uploadMachineData("remolque", "nortezac", "6 toneladas");

    // Start how to get sumary
    // this._getDocumentCountInColection("individualListings");
    // this._getDocumentCountInColection("accounts");
    // this._getDocumentCountInColection("businesses");
    // this._getArrayLength("accounts/CDLTykc4Bnav6fzZWwqw", "listings");
    // End how to get sumary

    // setTimeout(() => {
    //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
    //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
    //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
    //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
    //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
    //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
    // }, 3000);
    const notification = {
      title: "Test new user",
      body: "Test preferences notification.",
      url: "",
      openTo: "notification/fugichfbedjxn",
      image: "https://...",
      tag: "message-1",
      category: "important",
      inAppLink: "channel/8f4y9hf934/post/ugcreiwbkc"
    }
    const notificationBroadcast = {
      title: "MAI Braodcast Noti All 6.0",
      body: "This is a broadcast test notification.",
      url: "",
      image: "https://...",
      tag: "broadcast-1.0",
      category: "promotional",
      inAppLink: "broadcast"
    }

    const targetSystem = 'appNotifications'

    // this._NVCreateNotificationsForUsers({ requestId: crypto.randomUUID(), userIds: ['ZPww1k6WI6TfnGBlhIbHSByRbLI2', 'uxH81vCURJQdbFqNCtJdDhuLyII2'], notification })

    // this._NVWriteSystemNotification({ notification: notificationBroadcast, targetSystem })

    // this._getVideoUrlByPath('big add videos/land scape test vid.MOV')
  }


  _ALLINIT() {
    this._authStateHandlerOnceAndOnChange();
  }

  _getVideoUrlByPath(path = 'big add videos/0210.mov') {
    const storageRef = ref(storage, path);
    getDownloadURL(storageRef)
      .then((url) => {
        console.log("Video URL:", url);
      })
      .catch((error) => {
        console.error(error);
      });
  }






  async _getAndStoreFCMToken(userId, swRegistration) {
    try {
      const token = await getToken(messaging, {
        vapidKey: VAPIDKEY,
        serviceWorkerRegistration: swRegistration,
      });
      if (!token) {
        console.warn("No FCM token returned");
        return;
      }

      console.log("FCM token:", token);
      // alert(`FCM token:${token}`)

      const clientPlatformData = GENRALHELPERS._getClientPlatformInfo()

      console.log(clientPlatformData)

      const sendData = {
        token,
        platform: clientPlatformData.platform,
        os: clientPlatformData.os,
        browser: clientPlatformData.browser,
        isPWA: clientPlatformData.isPWA,
        permission: 'granted',
        appVersion: '3.0.0',
        locale: 'es-MX',
      }


      const result = await this._NVUpdateUserDeviceFCMToken(sendData)

      console.log(result)

      if (result.data.success) {
        // alert('Identificación de dispositivo exitoso.')
      } else {
        throw new Error(`ERROR: ${result.data.message}`)
      }

    } catch (err) {
      console.error("Error getting FCM token:", err);
      if (err?.code === "messaging/permission-blocked") {
        alert('No podimos activar tus notificaciones en este momento. Favor ingresa en los ajustes de tu dispositivo, y activa las notificaciones para esta aplicación. Después regrese a Mercado MAI, y vuele a abrir en menu de notificaciones para finalizar la activacion.')
      } else {
        alert(err.message)
      }
    }
  }
  async _storeNativeFCMToken(nativeToken) {
    try {
      if (!nativeToken) {
        console.warn("No native token provided");
        return;
      }

      console.log("📱 Native FCM token:", nativeToken);

      // 👇 You can reuse this if it works on native
      const clientPlatformData = GENRALHELPERS._getClientPlatformInfo();

      const sendData = {
        token: nativeToken,
        platform: "native", // or "android" if you want more specific
        os: clientPlatformData.os || "android",
        browser: "native-app",
        isPWA: false,
        permission: "granted",
        appVersion: "3.0.0",
        locale: "es-MX",
      };

      console.log("📤 Sending native token:", sendData);

      const result = await this._NVUpdateUserDeviceFCMToken(sendData);

      console.log(result);

      if (result.data.success) {
        console.log("✅ Native device registered");
      } else {
        throw new Error(`ERROR: ${result.data.message}`);
      }

    } catch (err) {
      console.error("Error storing native FCM token:", err);
    }
  }





  async _NVUpdateUserDeviceFCMToken(data) {
    console.log(data);
    try {
      console.log(data);
      const NVUpdateUserDeviceFCMToken = httpsCallable(functions, "NVUpdateUserDeviceFCMToken");
      const result = await NVUpdateUserDeviceFCMToken(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVCreateNotificationsForUsers(data) {
    console.log(data);
    // return
    try {
      console.log(data);
      const NVCreateNotificationsForUsers = httpsCallable(functions, "NVCreateNotificationsForUsers");
      const result = await NVCreateNotificationsForUsers(data);
      console.warn(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVWriteSystemNotification(data) {
    console.log(data);
    try {
      console.log(data);
      const NVWriteSystemNotification = httpsCallable(functions, "NVWriteSystemNotification");
      const result = await NVWriteSystemNotification(data);
      console.warn(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }





  // async _getNotifications(path, lastDoc = null) {
  //   try {
  //     const collectionRef = collection(db, path);

  //     let q = query(
  //       collectionRef,
  //       orderBy("createdAt", "desc"),
  //       limit(20)
  //     );

  //     // Pagination cursor
  //     if (lastDoc) {
  //       q = query(
  //         collectionRef,
  //         orderBy("createdAt", "desc"),
  //         startAfter(lastDoc),
  //         limit(20)
  //       );
  //     }

  //     const querySnapshot = await getDocs(q);

  //     if (querySnapshot.empty) {
  //       return {
  //         notifications: [],
  //         lastDoc: null,
  //         hasMore: false,
  //       };
  //     }

  //     const notifications = querySnapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     return {
  //       notifications,
  //       lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
  //       hasMore: querySnapshot.size === 20,
  //     };
  //   } catch (error) {
  //     console.error("Error getting notifications:", error);
  //     return {
  //       notifications: [],
  //       lastDoc: null,
  //       hasMore: false,
  //     };
  //   }
  // }

  async _getNotifications(path, category = "all", lastDoc = null) {
    try {
      const collectionRef = collection(db, path);

      const constraints = [
        orderBy("createdAt", "desc"),
        limit(10),
      ];

      // Optional category filter
      if (category !== "all") {
        constraints.unshift(where("category", "==", category));
      }

      // Pagination cursor
      if (lastDoc) {
        constraints.push(startAfter(lastDoc));
      }

      const q = query(collectionRef, ...constraints);
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        return {
          notifications: [],
          lastDoc: null,
          hasMore: false,
        };
      }

      const notifications = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return {
        notifications,
        lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
        hasMore: querySnapshot.size === 10,
      };
    } catch (error) {
      console.error("Error getting notifications:", error);
      return {
        notifications: [],
        lastDoc: null,
        hasMore: false,
      };
    }
  }



  async _NVSearchTest() {
    const NVSearchresults = await this._NVSearchSellersFunction({ query: "bernardo" })
    // const NVSearchresults = await this._NVSearchBusinessesFunction({ query: "silos" })
    // const NVSearchresults = await this._NVSearchListingsFunction({ query: "Generador en hopelchén" })
    console.log(NVSearchresults);
  }


  async _getStats(path) {
    // return;
    // Define the path to the stats node in Realtime Database
    const statsRef = dbRTRef(dbRT, path);

    try {
      // Fetch the data at the specified path
      const snapshot = await get(statsRef);

      if (snapshot.exists()) {
        // Get the count from the snapshot
        const count = snapshot.val();
        console.log(`Listings Created Count: ${count}`);
        return count;
      } else {
        console.log("No data available at the specified path.");
        return null;
      }
    } catch (error) {
      console.error("Error getting data:", error);
    }
  }

  // Call the function to get the stats

  _setNotificationOnWalletChange(title, body, butonLabel, buttonAction) {
    this.#notificationOnWalletChange = true;
    this.#notificationOnWalletChangeTitle = title;
    this.#notificationOnWalletChangeBody = body;
    this.#notificationOnWalletChangeButtonLabel = butonLabel;
    this.#notificationOnWalletChangeButtonAction = buttonAction;
  }

  _logToConsole(log) {
    console.log(log);
  }

  // Attach a listener to the document
  _onSnapShotForWallet(docId) {
    // Unsubscribe the previous listener
    if (this._currentUnsubscribe) {
      this._currentUnsubscribe();
      console.log("Previous listener unsubscribed.");
    }

    // Attach a new listener
    const unsubscribe = onSnapshot(
      doc(db, "wallets", docId),
      async (docSnapshot) => {
        if (docSnapshot.exists()) {
          // Get the updated document data
          const walletData = docSnapshot.data();
          console.log("Document data:", walletData);

          // Fetch the subcollection data (e.g., 'logs')
          const logsCollectionRef = collection(db, `wallets/${docId}/logs`);
          const logsSnapshot = await getDocs(logsCollectionRef);

          // Map and sort the logs by the 'time' field and then by 'tagName'
          const logs = logsSnapshot.docs
            .map((logDoc) => ({
              id: logDoc.id,
              ...logDoc.data(),
            }))
            .sort((a, b) => {
              // Primary sorting: by time (descending)
              const timeDifference = b.time.toMillis() - a.time.toMillis();
              if (timeDifference !== 0) return timeDifference;

              // Secondary sorting: prioritize 'salida' for matching times
              if (a.tagName === "salida" && b.tagName !== "salida") return 1;
              if (a.tagName !== "salida" && b.tagName === "salida") return -1;

              // Keep order unchanged for other cases
              return 0;
            });

          console.log("Sorted Logs subcollection data:", logs);
          if (this.#notificationOnWalletChange) {
            inAppNotification._showNotification(
              this.#notificationOnWalletChangeTitle,
              this.#notificationOnWalletChangeBody,
              this.#notificationOnWalletChangeButtonLabel,
              this.#notificationOnWalletChangeButtonAction
            );
            this.#notificationOnWalletChange = false;
          }

          // Optionally: Pass the data to a callback or handle it further
          // onUpdate({ wallet: walletData, logs });
        } else {
          console.log("Document does not exist!");
          // Optionally handle this case
          // onUpdate(null);
        }
      }
    );
    // Store the new unsubscribe function
    this._currentUnsubscribe = unsubscribe;
  }

  // Start get sumary functions
  async _getArrayLength(path, arrayField) {
    const docRef = doc(db, path);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();
      const array = data[arrayField];

      if (Array.isArray(array)) {
        console.log(`Length of the array '${arrayField}':`, array.length);
        return array.length;
      } else {
        console.log(`'${arrayField}' is not an array.`);
        return 0;
      }
    } else {
      console.log("Document does not exist.");
      return 0;
    }
  }
  async _getDocumentCountInColection(path) {
    const segments = path.split("/");
    let collectionRef;

    if (segments.length % 2 === 0) {
      // Path points to a sub-collection under a specific document
      const parentDoc = doc(db, segments.slice(0, -1).join("/"));
      collectionRef = collection(parentDoc, segments.at(-1));
    } else {
      // Path is a direct collection
      collectionRef = collection(db, path);
    }

    const snapshot = await getCountFromServer(collectionRef);
    console.log("Number of documents:", snapshot.data().count);
    return snapshot.data().count; // Return the count for further use
  }
  // End get sumary functions
  // Start record stats

  async _writeStats(activity, id) {
    try {
      const serverTimestampValue = serverTimestamp();

      // Add a temporary document to fetch the server timestamp
      const tempRef = await addDoc(collection(db, "temp"), {
        temp: true,
        timestamp: serverTimestampValue,
      });
      const tempDoc = await getDoc(tempRef);
      const serverTimestampData = tempDoc.data().timestamp;

      // Delete the temporary document
      await deleteDoc(tempRef);

      // Format date into Year and Month
      const date = serverTimestampData.toDate();
      const year = date.getFullYear().toString();
      const month = date.toLocaleString("default", { month: "long" });

      // Firestore path based on your nested structure
      const recordsCollectionPath = `stats/${activity}/years/${year}/months/${month}/records`;

      // Add a new activity document with an auto-generated ID under the "records" collection
      await addDoc(collection(db, recordsCollectionPath), {
        recordActivityId: id,
        timeStored: serverTimestampData,
      });

      console.log(
        `Activity "${activity}" with ID "${id}" successfully recorded in nested structure.`
      );
    } catch (error) {
      console.error("Error writing activity:", error);
    }
  }

  _addStatsToBatch(batch, activity, id) {
    const serverTimestampValue = serverTimestamp();

    // Format date into Year and Month
    const date = new Date();
    const year = date.getFullYear().toString();
    const month = date.toLocaleString("default", { month: "long" });

    // Firestore path based on your nested structure
    const recordsCollectionPath = `stats/${activity}/years/${year}/months/${month}/records`;

    // Create a new document reference with an auto-generated ID under the "records" collection
    const statsDocRef = doc(collection(db, recordsCollectionPath));

    // Add the stats write operation to the batch
    batch.set(statsDocRef, {
      recordActivityId: id,
      timeStored: serverTimestampValue,
    });

    console.log(
      `Stats for activity "${activity}" with ID "${id}" added to the batch.`
    );
  }

  async _getMonthlyRecords(path) {
    try {
      // Reference the "records" collection based on the provided path
      const recordsRef = collection(db, path);
      const querySnapshot = await getDocs(
        query(recordsRef, orderBy("timeStored", "desc"))
      );

      // Extract and organize the records
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      console.log("Monthly records retrieved:", records);
      return records;
    } catch (error) {
      console.error("Error retrieving monthly records:", error);
      return [];
    }
  }

  // End record stats

  async _getRecentListingsWithFilter(
    lastVisibleDoc = null,
    limitNumber = null, // Default is null, meaning no limit
    path,
    filterField = null,
    filterValue = null,
    sellerprofile = false
  ) {
    // Determine if the path is a direct collection or a sub-collection
    let collectionRef;
    const segments = path.split("/");

    if (segments.length % 2 === 1) {
      // Path points to a direct collection
      collectionRef = collection(db, path);
    } else {
      // Path points to a sub-collection under a specific document
      const parentDocPath = segments.slice(0, -1).join("/");
      const subCollectionName = segments.at(-1);
      collectionRef = collection(doc(db, parentDocPath), subCollectionName);
    }

    // Start building the query
    let queryObj = query(
      collectionRef,
      where("status", "==", "active"),
      orderBy("updatedAt", "desc")
    );

    // If filterField and filterValue are provided, add a 'where' clause to filter
    if (filterField && filterValue && !sellerprofile) {
      queryObj = query(
        collectionRef,
        where(filterField, "==", filterValue),
        where("status", "==", "active"),
        orderBy("updatedAt", "desc")
      );
    }
    if (filterField && filterValue && sellerprofile) {
      queryObj = query(
        collectionRef,
        where(filterField, "==", filterValue),
        orderBy("updatedAt", "desc")
      );
    }

    // Apply limit only if `limitNumber` is provided
    if (limitNumber) {
      queryObj = query(queryObj, limit(limitNumber)); // Add the limit
    }

    // If paginating, start after the last document from the previous batch
    if (lastVisibleDoc) {
      queryObj = query(queryObj, startAfter(lastVisibleDoc));
    }

    // Fetch query results
    const querySnapshot = await getDocs(queryObj);

    let docsToReturn = [];
    querySnapshot.forEach((doc) => {
      docsToReturn.push({ id: doc.id, ...doc.data() });
    });

    // Get the last document for pagination (for the next batch)
    const newLastVisibleDoc =
      querySnapshot.docs.length > 0
        ? querySnapshot.docs[querySnapshot.docs.length - 1]
        : null;

    return {
      listings: docsToReturn,
      lastVisibleDoc: newLastVisibleDoc, // Return the last document for pagination
    };
  }


  // // Haversine distance
  // getDistanceKm = (lat1, lng1, lat2, lng2) => {
  //   const R = 6371;
  //   const dLat = (lat2 - lat1) * Math.PI / 180;
  //   const dLng = (lng2 - lng1) * Math.PI / 180;

  //   const a =
  //     Math.sin(dLat / 2) ** 2 +
  //     Math.cos(lat1 * Math.PI / 180) *
  //     Math.cos(lat2 * Math.PI / 180) *
  //     Math.sin(dLng / 2) ** 2;

  //   return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  // }

  // // radius → geohash precision
  // getPrecision = (radiusKm) => {
  //   if (radiusKm <= 10) return 6;
  //   if (radiusKm <= 50) return 5;
  //   if (radiusKm <= 200) return 4;
  //   return 3;
  // }

  // async _getListingsNearby({
  //   lat,
  //   lng,
  //   radiusKm,
  //   lastVisible = null,
  //   pageSize = 20
  // }) {
  //   const db = getFirestore();

  //   const precision = this.getPrecision(radiusKm);

  //   const centerHash = ngeohash.encode(lat, lng, precision);
  //   const neighbors = ngeohash.neighbors(centerHash);

  //   const prefixes = [centerHash, ...neighbors];

  //   let allResults = [];

  //   for (const prefix of prefixes) {
  //     let q = query(
  //       collectionGroup(db, "listings"),
  //       where("status", "==", "active"),
  //       where("filterGeoHash", ">=", prefix),
  //       where("filterGeoHash", "<=", prefix + "\uf8ff"),
  //       orderBy("filterGeoHash"),
  //       limit(100) // batch per prefix
  //     );

  //     if (lastVisible) {
  //       q = query(q, startAfter(lastVisible));
  //     }

  //     const snap = await getDocs(q);

  //     snap.forEach(doc => {
  //       const data = doc.data();

  //       if (!data.filterLat || !data.filterLng) return;

  //       const distance = this.getDistanceKm(
  //         lat,
  //         lng,
  //         data.filterLat,
  //         data.filterLng
  //       );

  //       if (distance <= radiusKm) {
  //         allResults.push({
  //           id: doc.id,
  //           ...data,
  //           distance,
  //           _doc: doc
  //         });
  //       }
  //     });
  //   }

  //   // 🔥 Remove duplicates (important!)
  //   const uniqueMap = new Map();
  //   allResults.forEach(item => {
  //     uniqueMap.set(item.id, item);
  //   });

  //   let results = Array.from(uniqueMap.values());

  //   // 🔥 Sort by distance
  //   results.sort((a, b) => a.distance - b.distance);

  //   // 🔥 Pagination
  //   const paginated = results.slice(0, pageSize);

  //   const newLastVisible =
  //     paginated.length > 0
  //       ? paginated[paginated.length - 1]._doc
  //       : null;

  //   return {
  //     listings: paginated,
  //     lastVisible: newLastVisible
  //   };
  // }

  // async _getListingsNearby({
  //   lat,
  //   lng,
  //   radiusKm,
  //   lastVisibleMap = {}, // 👈 per-bound pagination
  //   pageSize = 20
  // }) {
  //   const db = getFirestore();

  //   const center = [lat, lng];
  //   const radiusInM = radiusKm * 1000;

  //   // 🔥 get ALL bounds needed to cover the circle
  //   const bounds = geohashQueryBounds(center, radiusInM);

  //   let allResults = [];

  //   const queries = bounds.map(async (b, i) => {
  //     let q = query(
  //       collectionGroup(db, "listings"),
  //       where("status", "==", "active"),
  //       orderBy("filterGeoHash"),
  //       startAt(b[0]),
  //       endAt(b[1]),
  //       limit(100)
  //     );

  //     // 👇 pagination per bound
  //     if (lastVisibleMap[i]) {
  //       q = query(q, startAfter(lastVisibleMap[i]));
  //     }

  //     const snap = await getDocs(q);

  //     return {
  //       docs: snap.docs,
  //       index: i
  //     };
  //   });

  //   const snapshots = await Promise.all(queries);

  //   let newLastVisibleMap = {};

  //   snapshots.forEach(({ docs, index }) => {
  //     if (docs.length > 0) {
  //       newLastVisibleMap[index] = docs[docs.length - 1];
  //     }

  //     docs.forEach(doc => {
  //       const data = doc.data();

  //       // if (!data.filterLat || !data.filterLng) return;
  //       if (
  //         typeof data.filterLat !== "number" ||
  //         typeof data.filterLng !== "number"
  //       ) return;

  //       // const distance = distanceBetween(
  //       //   [lat, lng],
  //       //   [data.filterLat, data.filterLng]
  //       // ) * 6371; // convert to km

  //       const distance = distanceBetween(
  //         [lat, lng],
  //         [data.filterLat, data.filterLng]
  //       );

  //       if (distance <= radiusKm) {
  //         allResults.push({
  //           id: doc.id,
  //           ...data,
  //           distance,
  //           _doc: doc
  //         });
  //       }
  //     });
  //   });

  //   // 🔥 remove duplicates
  //   const uniqueMap = new Map();
  //   allResults.forEach(item => {
  //     uniqueMap.set(item.id, item);
  //   });

  //   let results = Array.from(uniqueMap.values());

  //   // 🔥 sort by closest
  //   results.sort((a, b) => a.distance - b.distance);

  //   // 🔥 paginate final results
  //   const paginated = results.slice(0, pageSize);

  //   return {
  //     isAllListingsLoaded,
  //     listings: paginated,
  //     lastVisibleMap: newLastVisibleMap
  //   };
  // }




  async _getListingsNearby({
    lat,
    lng,
    radiusKm,
    lastVisibleMap = {}, // 👈 per-bound pagination
    pageSize = 20
  }) {
    const db = getFirestore();

    const center = [lat, lng];
    const radiusInM = radiusKm * 1000;

    // 🔥 get ALL bounds needed to cover the circle
    const bounds = geohashQueryBounds(center, radiusInM);

    let allResults = [];

    const queries = bounds.map(async (b, i) => {
      let q = query(
        collectionGroup(db, "listings"),
        where("status", "==", "active"),
        orderBy("filterGeoHash"),
        startAt(b[0]),
        endAt(b[1]),
        // limit(2)
        limit(100) // also line 989
      );

      // 👇 pagination per bound
      if (lastVisibleMap?.[i]) {
        q = query(q, startAfter(lastVisibleMap[i]));
      }

      const snap = await getDocs(q);

      return {
        docs: snap.docs,
        index: i
      };
    });

    const snapshots = await Promise.all(queries);

    let newLastVisibleMap = {};
    let isAllListingsLoaded = true; // 👈 assume true

    snapshots.forEach(({ docs, index }) => {
      // 👇 if any query hits the limit, more data might exist
      // if (docs.length === 2) {
      //   isAllListingsLoaded = false;
      // }
      if (docs.length === 100) {
        isAllListingsLoaded = false;
      }

      if (docs.length > 0) {
        newLastVisibleMap[index] = docs[docs.length - 1];
      }

      docs.forEach(doc => {
        const data = doc.data();

        if (
          typeof data.filterLat !== "number" ||
          typeof data.filterLng !== "number"
        ) return;

        const distance = distanceBetween(
          [lat, lng],
          [data.filterLat, data.filterLng]
        );

        if (distance <= radiusKm) {
          allResults.push({
            id: doc.id,
            ...data,
            distance,
            _doc: doc
          });
        }
      });
    });

    // 🔥 remove duplicates
    const uniqueMap = new Map();
    allResults.forEach(item => {
      uniqueMap.set(item.id, item);
    });

    let results = Array.from(uniqueMap.values());

    // 🔥 sort by closest
    results.sort((a, b) => a.distance - b.distance);

    // 🔥 paginate final results
    const paginated = results.slice(0, pageSize);

    return {
      listings: paginated,
      lastVisibleMap: newLastVisibleMap,
      isAllListingsLoaded,
    };
  }


  async _getMostRecentListingsWithOutFilterGlobal(
    lastVisibleDoc = null, // 🕘 Last doc from previous batch (for pagination)
    limitNumber = 10 // 📌 Default limit (fetch 10 listings)
  ) {
    const db = getFirestore();

    // 🔥 Base query: Get all 'listings' subcollections across Firestore
    let queryObj = query(
      collectionGroup(db, "listings"),
      where("status", "==", "active"),
      orderBy("updatedAt", "desc"),
      limit(limitNumber) // ⏳ Limit to `limitNumber` results
    );

    // 🔥 If paginating, start after the last document from the previous batch
    if (lastVisibleDoc) {
      queryObj = query(queryObj, startAfter(lastVisibleDoc));
    }

    // 🚀 Fetch query results
    const querySnapshot = await getDocs(queryObj);

    // 📝 Extract listings
    let listings = [];
    querySnapshot.forEach((doc) => {
      listings.push({ id: doc.id, ...doc.data() });
      // console.log('Listing path:', doc.ref.path);
      // console.log('path:', doc.ref.path);
      // console.log('data:', doc.data());
    });

    // 🔚 Get the last document for pagination
    const newLastVisibleDoc =
      querySnapshot.docs.length > 0
        ? querySnapshot.docs[querySnapshot.docs.length - 1]
        : null;

    return {
      listings,
      lastVisibleDoc: newLastVisibleDoc, // 🔄 Save this to fetch the next batch
    };
  }


  async _getMostRelevantListingsWithFilter(
    lastVisibleDoc = null, // 🕘 Last doc from previous batch (for pagination)
    limitNumber = 10, // 📌 Default limit (fetch 10 listings)
    filterField = null,
    filterValue = null
  ) {
    const db = getFirestore();

    // 🔥 Base query: Get all 'listings' subcollections across Firestore
    let queryObj = query(
      collectionGroup(db, "listings"),
      where("status", "==", "active"),
      orderBy("score", "desc"),
      limit(limitNumber) // ⏳ Limit to `limitNumber` results
    );

    // ✅ Apply additional filter if provided
    if (filterField && filterValue) {
      queryObj = query(
        collectionGroup(db, "listings"),
        where(filterField, "==", filterValue),
        where("status", "==", "active"),
        orderBy("score", "desc"),
        limit(limitNumber)
      );
    }

    // 🔥 If paginating, start after the last document from the previous batch
    if (lastVisibleDoc) {
      queryObj = query(queryObj, startAfter(lastVisibleDoc));
    }

    // 🚀 Fetch query results
    const querySnapshot = await getDocs(queryObj);

    // 📝 Extract listings
    let listings = [];
    querySnapshot.forEach((doc) => {
      listings.push({ id: doc.id, ...doc.data() });
    });

    // 🔚 Get the last document for pagination
    const newLastVisibleDoc =
      querySnapshot.docs.length > 0
        ? querySnapshot.docs[querySnapshot.docs.length - 1]
        : null;

    return {
      listings,
      lastVisibleDoc: newLastVisibleDoc, // 🔄 Save this to fetch the next batch
    };
  }

  async _getAllDocumentsFromPath(path) {
    try {
      const collectionRef = collection(db, path); // Reference to the collection
      const querySnapshot = await getDocs(collectionRef); // Get all documents in the collection

      if (!querySnapshot.empty) {
        const documents = querySnapshot.docs.map((doc) => ({
          id: doc.id, // Document ID
          ...doc.data(), // Document data
        }));
        console.log("Documents data:", documents);
        return documents; // Return the list of documents
      } else {
        console.log("No documents found in the collection.");
        return [];
      }
    } catch (error) {
      console.error("Error getting documents:", error);
      return [];
    }
  }


  async _getAllAffiliatedItemsPaginated(
    path,
    pageSize = 10,
    lastDoc = null
  ) {
    try {

      const baseRef = collection(db, path);

      let q;

      if (lastDoc) {
        q = query(
          baseRef,
          orderBy("createdAt", "desc"),
          startAfter(lastDoc),
          limit(pageSize)
        );
      } else {
        q = query(
          baseRef,
          orderBy("createdAt", "desc"),
          limit(pageSize)
        );
      }

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        return { items: [], lastDoc: null };
      }

      const items = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const newLastDoc =
        snapshot.docs[snapshot.docs.length - 1];

      return {
        items,
        lastDoc: newLastDoc
      };

    } catch (error) {
      console.error("Error fetching affiliated items:", error);
      return { items: [], lastDoc: null };
    }
  }

  async _getAllDocsFromPathByMostRecent(collectionPath, listings, onlyNum = null) {
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    const constraints = [];

    if (listings) {
      constraints.push(where("status", "==", "active"));
      constraints.push(orderBy("updatedAt", "desc"));
    } else {
      constraints.push(orderBy("lastSeenAt", "desc"));
    }

    // 🔢 Optional limit
    if (typeof onlyNum === "number" && onlyNum > 0) {
      constraints.push(limit(onlyNum));
    }

    const q = query(collection(db, collectionPath), ...constraints);
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("No logs found.");
      return [];
    }

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  }

  async _loadComments(collectionPath) {
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    const constraints = [];

    constraints.push(orderBy("createdAt", "desc"));

    // // 🔢 Optional limit
    // if (typeof onlyNum === "number" && onlyNum > 0) {
    //   constraints.push(limit(onlyNum));
    // }

    const q = query(collection(db, collectionPath), ...constraints);
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("No logs found.");
      return [];
    }

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  }


  async _getMachineData(path) {
    try {
      const docRef = doc(db, path); // Reference to the document at the specified path
      const docSnap = await getDoc(docRef); // Get the document snapshot

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data()); // The data of the document
        return docSnap.data(); // Return the data if it exists
      } else {
        console.log("No such document!"); // If the document doesn't exist
        return null;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return null; // Return null in case of error
    }
  }
  async _getAnyDocById(path) {
    console.warn(path);
    try {
      const docRef = doc(db, path); // Reference to the document at the specified path
      const docSnap = await getDoc(docRef); // Get the document snapshot

      if (docSnap.exists()) {
        return docSnap.data(); // Return the data if it exists
      } else {
        console.log("No such document!"); // If the document doesn't exist
        return null;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return null; // Return null in case of error
    }
  }

  async _uploadMachineData(machineData) {
    try {
      const machineCollectionRef = collection(db, "machines"); // Reference to the "machines" collection

      // Iterate through each machine type (tractor, combineHarvester, etc.)
      for (const [machineType, manufacturers] of Object.entries(machineData)) {
        const machineDocRef = doc(machineCollectionRef, machineType); // Create a document for each machine type

        // Set the data for the machine type document
        await setDoc(machineDocRef, { manufacturers });

        console.log(`Machine data for ${machineType} uploaded successfully`);
      }
    } catch (error) {
      console.error("Error uploading machine data: ", error);
    }
  }

  async _createUserAccountDocument(data) {
    const batch = writeBatch(db); // Create a batch instance
    try {
      // Collection reference for the accounts
      const accountsCollection = collection(db, "accounts");

      // Generate a new document reference with an auto-generated ID
      const accountDocRef = doc(accountsCollection);
      const userId = accountDocRef.id;
      console.log(userId);

      // Prepare the account document data
      const accountData = {
        userId: userId,
        email: data.email,
        userName: data.userName,
        password: data.password, // Ensure this is hashed if necessary
        termsAccepted: data.termsAccepted,
        likes: [],
        pastSaves: [],
        activeSaves: [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      // Add the account document to the batch
      batch.set(accountDocRef, accountData);

      // Add stats to the batch
      this._addStatsToBatch(batch, "accountsCreated", userId);

      // Commit the batch
      await batch.commit();

      // Return success data
      return { success: true, userId };
    } catch (error) {
      console.error("Error creating user account document:", error);
      throw new Error("Failed to create user account document");
    }
  }
  async _updateExistingBusinessDocument(
    data,
    imgBack,
    imgProfile,
    accountId,
    businessId
  ) {
    try {
      let tokens = [];

      const generatedTokesForName = GENRALHELPERS._createTokens(
        data.name,
        omittedWordsInTokens
      );
      const generatedTokesForDescription = GENRALHELPERS._createTokens(
        data.shortDescription,
        omittedWordsInTokens
      );

      generatedTokesForName.forEach((token) => {
        tokens.push(token);
      });
      generatedTokesForDescription.forEach((token) => {
        tokens.push(token);
      });
      // Create a batch instance
      const batch = writeBatch(db);

      // Reference to the existing business document
      const businessDocRef = doc(db, `businesses/${businessId}`);

      // Prepare the updated business data
      const updatedBusinessData = {
        name: data.name,
        shortDescription: data.shortDescription,
        backgroundImg: imgBack,
        profileImg: imgProfile,
        about: data.about,
        listingsApear: data.listingsApear,
        place: data.place,
        contacts: data.contacts,
        lists: data.lists,
        colors: data.colors,
        businessTokens: tokens,
        status: "active",
        updatedAt: serverTimestamp(),
      };

      // Set the updates in the batch
      batch.update(businessDocRef, updatedBusinessData);

      // Commit the batch
      await batch.commit();

      // Return success response
      return { success: true, businessId };
    } catch (error) {
      console.error("Error updating business document:", error);
      throw new Error("Failed to update the business document");
    }
  }

  async _getAccountDataById(accountId) {
    try {
      const docRef = doc(db, "accounts", accountId); // Reference to the document
      const docSnapshot = await getDoc(docRef); // Fetch the document

      if (docSnapshot.exists()) {
        return docSnapshot.data(); // Return the document data if it exists
      } else {
        console.log("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      throw new Error("Failed to fetch account data");
    }
  }
  // async _getBusinessById2(businessId) {
  //   try {
  //     const docRef = doc(db, "businesses", businessId); // Reference to the document
  //     const docSnapshot = await getDoc(docRef); // Fetch the document

  //     if (docSnapshot.exists()) {
  //       return docSnapshot.data(); // Return the document data if it exists
  //     } else {
  //       console.log("No such document!");
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error("Error getting document:", error);
  //     throw new Error("Failed to fetch account data");
  //   }
  // }
  async _getBusinessById(businessId) {
    try {
      const docRef = doc(db, "businesses", businessId); // Reference to the document
      const docSnapshot = await getDoc(docRef); // Fetch the document

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        console.log(data);
        if (data.status === "active") {
          return data; // Return the document data if the status is "active"
        } else {
          console.log("Document exists but is not active");
          return data;
        }
      } else {
        console.log("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      throw new Error("Failed to fetch account data");
    }
  }

  async _getAccountDataByEmail(email) {
    try {
      const accountsRef = collection(db, "accounts");
      const q = query(accountsRef, where("email", "==", email)); // Query for email match
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // If there are matching documents, return the first one
        const accountData = querySnapshot.docs[0].data();
        return accountData;
      } else {
        console.log("No account found with the provided email.");
        return null;
      }
    } catch (error) {
      console.error("Error getting account by email:", error);
      throw new Error("Failed to fetch account data by email");
    }
  }

  async _subscriptionHandle() {
    const url = "https://createsubscription-vu7zimlfzq-uc.a.run.app";

    const subscriptionData = {
      accountId: "HwoQpx8HJjrQM1iV3wfN",
      numberOfListingsIncluded: 30,
      amount: 200,
      time: 30, // Duration in days
    };

    console.log("Sending subscription data:", subscriptionData);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscriptionData),
      });

      const result = await response.json();

      if (response.ok && result.status === "success") {
        console.log("Subscription created successfully.");
        return { success: true };
      } else {
        console.error("Failed to create subscription:", result.error);
        return { success: false, error: result.error || "Unknown error" };
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      return { success: false, error: error.message };
    }
  }





  async _uploadImagesAndGetReferences(id, progressConId, noChildren = false, adminPath, isFrom = 'listing') {
    console.log('id', id);

    const imagesContainer = document.getElementById(id);
    const progressCon = document.getElementById(progressConId);

    progressCon.style.display = "flex";

    let existingListingImages = []

    if (isFrom === 'listing') {
      existingListingImages = createListing._getListingImageArr?.() || [];
    }

    if (isFrom === 'businessBackground') {
      existingListingImages = [NVBusinessEditor._getImages?.('back')] || [];
    }
    if (isFrom === 'businessProfile') {
      existingListingImages = [NVBusinessEditor._getImages?.('prof')] || [];
    }

    console.log(existingListingImages);

    function isFirebaseStorageUrl(url) {
      return url.includes("storage.googleapis.com") ||
        url.includes("firebasestorage.googleapis.com");
    }

    // --- Collect image elements ---
    let imageFiles = [];

    if (noChildren) {

      const singleImg = imagesContainer.tagName === "IMG"
        ? imagesContainer
        : imagesContainer.querySelector("img"); console.log('here');

      if (!singleImg || !singleImg.src) return [];

      imageFiles = [singleImg];
      console.log('here', imageFiles);


    } else {

      console.log('imagesContainer', imagesContainer);

      imageFiles = Array.from(imagesContainer.querySelectorAll("img"));

    }

    if (imageFiles.length === 0) return [];
    console.log('here');

    let uploadedImages = [];

    const con = document.getElementById(
      `SearchStartUpComponentAllCon`
    );

    console.log(con);
    if (con) con.remove();

    // --- Progress UI ---
    progressCon.innerHTML = `
  <div style="width:100%;background:rgba(0,0,0,0.1);border-radius:6px;height:8px;overflow:hidden;margin-top:10px;">
    <div id="progressBarFill" style="width:0%;height:100%;background:linear-gradient(90deg,#4ade80,#16a34a);transition:width 0.3s ease;"></div>
  </div>
  <div id="progressText" style="text-align:center;font-size:13px;color:#555;margin-top:6px;font-family:system-ui,sans-serif;">Preparando...</div>
  `;

    const progressBarFill = progressCon.querySelector("#progressBarFill");
    const progressText = progressCon.querySelector("#progressText");

    // --- Convert src → File ---
    async function srcToFile(src, filename = "image.jpg") {

      if (src.startsWith("data:image")) {

        const arr = src.split(",");
        const mimeMatch = arr[0].match(/:(.*?)(;|,)/);
        const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";

        const bstr = atob(arr[1]);
        const u8arr = new Uint8Array(bstr.length);

        for (let i = 0; i < bstr.length; i++) {
          u8arr[i] = bstr.charCodeAt(i);
        }

        return new File([u8arr], filename, { type: mime });

      } else {

        const res = await fetch(src);
        const blob = await res.blob();

        return new File([blob], filename, {
          type: blob.type || "image/jpeg",
        });

      }

    }

    // --- Resize + convert to AVIF ---
    function resizeAndConvertToAvif(file, maxWidth = 1200) {

      return new Promise((resolve, reject) => {

        const img = new Image();
        const reader = new FileReader();

        reader.onload = e => img.src = e.target.result;
        reader.onerror = () => reject(new Error("Failed to read file."));
        reader.readAsDataURL(file);

        img.onload = () => {

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            blob => blob ? resolve(blob) : reject(new Error("AVIF conversion failed")),
            "image/avif",
            0.7
          );

        };

        img.onerror = () => reject(new Error("Image load failed"));

      });

    }

    try {

      // const totalImages = imageFiles.length;


      // Only images that will actually be processed
      const imagesToProcess = imageFiles.filter(img => {
        const src = img.src;
        if (!src) return false;

        const shouldUpload = img.classList.contains("uploadSpecific");
        const isFirebase = isFirebaseStorageUrl(src);

        return shouldUpload || isFirebase;
      });

      const totalImages = imagesToProcess.length;

      console.log(imagesToProcess);
      console.log(`Total images to process: ${totalImages}`);

      for (let i = 0; i < totalImages; i++) {

        const imgElement = imagesToProcess[i];
        const src = imgElement.src;

        if (!src) continue;

        const shouldUpload = imgElement.classList.contains("uploadSpecific");

        // --- Handle existing Firebase images BEFORE fetch ---
        if (isFirebaseStorageUrl(src)) {

          const existingObj = existingListingImages.find(
            img => img.res_original === src
          );
          console.log(existingObj);


          if (isFrom === 'businessBackground') {
            uploadedImages = existingListingImages
          } else if (isFrom === 'businessProfile') {
            uploadedImages = existingListingImages
          } else {
            uploadedImages.push(existingObj || { res_original: src });
          }

          console.info(`Using existing Firebase image (${i + 1}/${totalImages})`);
          continue;
        }

        // --- Skip images not marked for upload ---
        if (!shouldUpload) {

          console.info(`Skipping non-upload image (${i + 1}/${totalImages})`);
          continue;

        }

        // --- Upload new image ---
        const imageFile = await srcToFile(src, `image_${i}.jpg`);
        const resizedImage = await resizeAndConvertToAvif(imageFile, 1200);

        const fileId = `${uuidv4()}.avif`;

        const storageRef = ref(storage, `${adminPath}/${fileId}`);
        const uploadTask = uploadBytesResumable(storageRef, resizedImage);

        const uploadedUrl = await new Promise((resolve, reject) => {

          uploadTask.on(
            "state_changed",

            snapshot => {

              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              const overall = ((i + progress / 100) / totalImages) * 100;

              if (progressBarFill) {
                progressBarFill.style.width = `${overall.toFixed(1)}%`;
              }

              if (progressText) {
                progressText.textContent =
                  `Cargando imagen ${i + 1}/${totalImages} — ${overall.toFixed(0)}%`;
              }

            },

            reject,

            async () => {

              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(downloadURL);

            }
          );

        });

        uploadedImages.push({
          res_original: uploadedUrl
        });

      }

      if (progressText) {
        progressText.textContent = "Imágenes cargadas con éxito!";
      }

      if (progressBarFill) {
        progressBarFill.style.background =
          "linear-gradient(90deg,#22c55e,#15803d)";
      }

      return uploadedImages;

    } catch (error) {

      console.error("Error in image upload process:", error);

      if (progressText) {
        progressText.textContent = "Error al cargar imágenes. Intente de nuevo.";
      }

      if (progressBarFill) {
        progressBarFill.style.background = "#dc2626";
      }

      throw new Error("Failed to upload images.");

    } finally {

      progressCon.style.display = "none";

    }

  }

  async _uploadImageById(id) {
    const imgElement = document.getElementById(id);

    if (!imgElement) {
      console.log("Image not found.");
      return null;
    }

    // Convert data URL to File object
    function dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }

    // Resize image to specified dimensions
    function resizeImage(file, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = (e) => (img.src = e.target.result);
        reader.onerror = () => reject(new Error("Failed to read file."));
        reader.readAsDataURL(file);
        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) =>
              blob
                ? resolve(blob)
                : reject(new Error("Failed to resize image.")),
            "image/jpeg",
            0.7
          );
        };
        img.onerror = () => reject(new Error("Failed to load image."));
      });
    }

    try {
      const imageSrc = imgElement.src;

      if (!imageSrc.startsWith("data:")) {
        throw new Error("Only data URL images can be processed.");
      }

      const imageFile = dataURLtoFile(imageSrc, `${id}.jpg`);
      console.log(imageFile);

      const resizedImage = await resizeImage(imageFile, 800, 800);
      console.log(resizedImage);

      // Generate a unique file ID
      const fileId = `${uuidv4()}.jpg`;
      const storageRef = ref(storage, `images/${fileId}`);

      // Upload the resized image to Firebase
      await uploadBytes(storageRef, resizedImage);

      // Get the public URL for the uploaded image
      const downloadURL = await getDownloadURL(storageRef);

      return downloadURL; // Return the URL of the uploaded image
    } catch (error) {
      console.error("Error in image upload process:", error);
      throw new Error("Failed to upload the image. Please try again.");
    }
  }

  // TODO Should not be uesed any more
  async _getImageUrlNOTINUSE(imgId) {
    const cacheName = "image-cache";

    try {
      if (!imgId || imgId.trim() === "") {
        throw new Error("Image ID is missing or invalid.");
      }

      const imageKey = `images/${imgId}`;

      // Open the cache
      const cache = await caches.open(cacheName);

      // Check if the image is already in the cache
      const cachedResponse = await cache.match(imageKey);
      if (cachedResponse) {
        const blob = await cachedResponse.blob(); // Convert to blob
        const blobUrl = URL.createObjectURL(blob); // Create a Blob URL
        return blobUrl;
      }

      // If the image is not in the cache, download it from Firebase Storage
      const storageRef = ref(storage, imageKey);
      const imageUrl = await getDownloadURL(storageRef);

      // Fetch the image as a blob
      const fetchResponse = await fetch(imageUrl);
      if (!fetchResponse.ok) {
        throw new Error("Failed to fetch the image from URL");
      }

      // Cache the fetched image
      await cache.put(imageKey, fetchResponse.clone());

      // Return the fetched image URL
      const blob = await fetchResponse.blob();
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    } catch (error) {
      console.error(`Failed to load image with ID '${imgId}':`, error);
      throw new Error("Failed to retrieve image URL.");
    }
  }

  async _addDocumentToSubcollection(path, subcollectionName, docObject) {
    try {
      const parentDocRef = doc(db, path); // Reference to the parent document
      const subcollectionRef = collection(parentDocRef, subcollectionName); // Subcollection reference
      const newDocRef = await addDoc(subcollectionRef, docObject);
      console.log(`Document added with ID: ${newDocRef.id}`);
      return newDocRef.id;
    } catch (error) {
      console.error("Error adding document to subcollection:", error);
      throw error;
    }
  }

  async _removeDocumentFromSubcollection(path, subcollectionName, key, value) {
    try {
      const parentDocRef = doc(db, path); // Reference to the parent document
      const subcollectionRef = collection(parentDocRef, subcollectionName); // Subcollection reference
      const q = query(subcollectionRef, where(key, "==", value)); // Query to find matching documents
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        console.log("No matching documents found.");
        return;
      }

      for (const docSnapshot of querySnapshot.docs) {
        await deleteDoc(docSnapshot.ref);
        console.log(`Document with ID ${docSnapshot.id} deleted.`);
      }
    } catch (error) {
      console.error("Error removing document from subcollection:", error);
      throw error;
    }
  }

  async _storeMachineData(machine, brand, model, metadata = {}) {
    try {
      // Add machine to the `machineTypes` collection
      const machineRef = doc(db, `machineTypes/${machine}`);
      await setDoc(
        machineRef,
        { name: machine }, // Add a 'name' field to represent the machine type
        { merge: true } // Merge to avoid overwriting existing data
      );

      // Add brand to the `brands` subcollection
      const brandRef = doc(db, `machineTypes/${machine}/brands/${brand}`);
      await setDoc(
        brandRef,
        { name: brand }, // Add a 'name' field to represent the brand
        { merge: true } // Merge to avoid overwriting existing data
      );

      // Add model to the `models` subcollection
      const modelRef = doc(
        db,
        `machineTypes/${machine}/brands/${brand}/models/${model}`
      );
      await setDoc(
        modelRef,
        { name: model, ...metadata }, // Add metadata for the model
        { merge: true } // Merge to avoid overwriting existing data
      );

      console.log(
        `Data stored successfully for ${machine} -> ${brand} -> ${model}`
      );
    } catch (error) {
      console.error("Error storing data:", error);
    }
  }
  async _getMachineData(path) {
    try {
      // Determine if the path points to a collection or document
      const pathParts = path.split("/");
      const isCollection = pathParts.length % 2 !== 0; // Odd-length paths point to collections

      if (isCollection) {
        // Fetch all documents in the collection
        const collectionRef = collection(db, path);
        const querySnapshot = await getDocs(collectionRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));

        // console.log(`Data retrieved for collection '${path}':`, data);
        return data; // Array of documents
      } else {
        // Fetch a single document
        const docRef = doc(db, path);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log(`Data retrieved for document '${path}':`, docSnap.data());
          return docSnap.data(); // Object containing document data
        } else {
          console.log(`No document found at path '${path}'`);
          return null; // Return null if the document does not exist
        }
      }
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error; // Re-throw the error for further handling
    }
  }
  async _searchListings(
    collectionPath,
    searchInput,
    omittedWords = ["de", "para", "el", "del", "y", "en", "con"]
  ) {
    // Ensure `db` is properly initialized
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    // Tokenize the search input
    const searchTokens = GENRALHELPERS._createTokens(searchInput, omittedWords);

    if (searchTokens.length === 0) {
      console.warn("No valid tokens generated from the search input.");
      return [];
    }

    // Query Firestore with 'array-contains-any' for matching tokens
    const querySnapshot = await getDocs(
      query(
        collection(db, collectionPath),
        where("listingTokens", "array-contains-any", searchTokens)
      )
    );

    if (querySnapshot.empty) {
      console.log("No matching listings found.");
      return [];
    }

    // Collect and return matching listings
    const listings = [];
    querySnapshot.forEach((doc) => {
      listings.push({ id: doc.id, ...doc.data() });
    });

    return listings;
  }
  async _searchBusinesses(
    searchInput,
    omittedWords = ["de", "para", "el", "del", "y", "en", "con"],
    lastVisibleDoc = null,
    pageSize = 10
  ) {
    // Ensure `db` is properly initialized
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    // Tokenize the search input
    console.log(searchInput);
    let searchTokens = [];
    if (searchInput) {
      searchTokens = GENRALHELPERS._createTokens(searchInput, omittedWords);
    }

    // Initialize the query
    let searchQuery;

    if (searchTokens.length === 0) {
      // No search input: return all businesses ordered by priorityLevelPoints (descending) and updatedAt (recent first)
      searchQuery = query(
        collection(db, "businesses"),
        orderBy("updatedAt", "desc"),
        limit(pageSize)
      );
    } else {
      // Search input provided: query by tokens, then order by priority and updatedAt
      searchQuery = query(
        collection(db, "businesses"),
        where("businessTokens", "array-contains-any", searchTokens),
        orderBy("updatedAt", "desc"),
        limit(pageSize)
      );
    }

    // Apply pagination if `lastVisibleDoc` is provided
    if (lastVisibleDoc) {
      searchQuery = query(searchQuery, startAfter(lastVisibleDoc));
    }

    // Execute the query
    try {
      const querySnapshot = await getDocs(searchQuery);

      if (querySnapshot.empty) {
        console.log("No matching businesses found.");
        return { results: [], lastVisibleDoc: null };
      }

      // Collect and return matching businesses
      const businesses = [];
      querySnapshot.forEach((doc) => {
        businesses.push({ id: doc.id, ...doc.data() });
      });

      // Get the last document for pagination
      const newLastVisibleDoc =
        querySnapshot.docs[querySnapshot.docs.length - 1] || null;

      return {
        results: businesses, // The retrieved businesses
        lastVisibleDoc: newLastVisibleDoc, // The last document for the next page
      };
    } catch (error) {
      console.error("Error searching businesses by priority:", error);
      throw error;
    }
  }
  async _searchSellerProfiles(
    searchInput,
    omittedWords = ["de", "para", "el", "del", "y", "en", "con"],
    lastVisibleDoc = null,
    pageSize = 10
  ) {
    // Ensure `db` is properly initialized
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    // Tokenize the search input
    console.log(searchInput);
    let searchTokens = [];
    if (searchInput) {
      searchTokens = GENRALHELPERS._createTokens(searchInput, omittedWords);
    }

    // Initialize the query
    let searchQuery;

    if (searchTokens.length === 0) {
      // No search input: return all businesses ordered by priorityLevelPoints (descending) and updatedAt (recent first)
      searchQuery = query(
        collection(db, "accounts"),
        orderBy("updatedAt", "desc"),
        limit(pageSize)
      );
    } else {
      // Search input provided: query by tokens, then order by priority and updatedAt
      searchQuery = query(
        collection(db, "accounts"),
        where("sellerProfileTokens", "array-contains-any", searchTokens),
        orderBy("updatedAt", "desc"),
        limit(pageSize)
      );
    }

    // Apply pagination if `lastVisibleDoc` is provided
    if (lastVisibleDoc) {
      searchQuery = query(searchQuery, startAfter(lastVisibleDoc));
    }

    // Execute the query
    try {
      const querySnapshot = await getDocs(searchQuery);

      if (querySnapshot.empty) {
        console.log("No matching businesses found.");
        return { results: [], lastVisibleDoc: null };
      }

      // Collect and return matching businesses
      const businesses = [];
      querySnapshot.forEach((doc) => {
        businesses.push({ id: doc.id, ...doc.data() });
      });

      // Get the last document for pagination
      const newLastVisibleDoc =
        querySnapshot.docs[querySnapshot.docs.length - 1] || null;

      return {
        results: businesses, // The retrieved businesses
        lastVisibleDoc: newLastVisibleDoc, // The last document for the next page
      };
    } catch (error) {
      console.error("Error searching businesses by priority:", error);
      throw error;
    }
  }
  async _searchListingsGlobal(
    searchInput,
    omittedWords = ["de", "para", "el", "del", "y", "en", "con"],
    lastVisibleDocument = null, // For pagination: the last document from the previous page
    pageSize = 10 // Default to 10 results per page
  ) {
    // Ensure `db` is properly initialized
    if (!db) {
      throw new Error(
        "Firestore is not initialized. Please call _initFirebase first."
      );
    }

    // Tokenize the search input
    const searchTokens = GENRALHELPERS._createTokens(searchInput, omittedWords);

    if (searchTokens.length === 0) {
      console.warn("No valid tokens generated from the search input.");
      return [];
    }

    // Start the base query for global search across all subcollections
    let queryRef = query(
      collectionGroup(db, "listings"), // Search across all 'listings' subcollections
      where("status", "==", "active"), // Token search
      where("listingTokens", "array-contains-any", searchTokens), // Token search
      orderBy("score", "desc"), // Order by priorityLevelPoints in descending order (highest first)
      limit(pageSize) // Limit to a specific number of results (pagination)
    );

    // If we are on a subsequent page, apply the startAfter condition for pagination
    if (lastVisibleDocument) {
      queryRef = query(queryRef, startAfter(lastVisibleDocument));
    }

    // Execute the query and get the snapshot
    const querySnapshot = await getDocs(queryRef);

    if (querySnapshot.empty) {
      console.log("No matching listings found.");
      return [];
    }

    // Collect the listings
    const listings = [];
    querySnapshot.forEach((doc) => {
      listings.push({ id: doc.id, ...doc.data() });
    });
    // Get the last visible document to use for pagination in the next page
    const lastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

    return {
      listings, // The current page of results
      lastVisibleDoc, // The last document for pagination (used in the next search call)
    };
  }

  async _globalGetFromMostRecentWithOutPriority(lastVisibleDoc, pageSize = 10) {
    const results = [];

    try {
      // Reference the collection group using the initialized Firestore instance
      let searchQuery = query(collectionGroup(db, "listings"));

      searchQuery = query(
        searchQuery,
        where("status", "==", "active") // Filter documents with "listingDiscount"
      );

      // Order by 'priorityLevelPoints' in descending order to get the highest first
      searchQuery = query(searchQuery, orderBy("updatedAt", "desc"));

      // Apply pagination
      if (lastVisibleDoc) {
        searchQuery = query(searchQuery, startAfter(lastVisibleDoc));
      }

      // Limit the number of results
      searchQuery = query(searchQuery, limit(pageSize));

      // Execute the query
      const snapshot = await getDocs(searchQuery);

      // Process the results
      snapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      // Get the last document for the next page
      const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;

      return {
        results, // The retrieved results
        lastVisibleDoc: newLastVisibleDoc, // The last document for the next query
      };
    } catch (error) {
      console.error("Error performing global search with pagination:", error);
      throw error;
    }
  }

  async _globalTargetedSearch(
    lastVisibleDoc,
    machine,
    brand,
    model,
    discount,
    pageSize = 10
  ) {
    const results = [];

    try {
      // Reference the collection group using the initialized Firestore instance
      let searchQuery = query(collectionGroup(db, "listings"));

      // Dynamically build the query based on the specified parameters
      if (machine && machine !== "todos") {
        searchQuery = query(
          searchQuery,
          where("listingMachineType", "==", machine)
        );
      }
      if (brand && brand !== "todos") {
        searchQuery = query(searchQuery, where("listingBrand", "==", brand));
      }
      if (model && model !== "todos") {
        searchQuery = query(searchQuery, where("listingModel", "==", model));
      }
      if (discount) {
        searchQuery = query(
          searchQuery,
          where("listingDiscount", "==", "onDiscount") // Filter documents with "listingDiscount"
        );
      }
      searchQuery = query(
        searchQuery,
        where("status", "==", "active") // Filter documents with "listingDiscount"
      );

      // Order by 'priorityLevelPoints' in descending order to get the highest first
      searchQuery = query(searchQuery, orderBy("score", "desc"));

      // Apply pagination
      if (lastVisibleDoc) {
        searchQuery = query(searchQuery, startAfter(lastVisibleDoc));
      }

      // Limit the number of results
      searchQuery = query(searchQuery, limit(pageSize));

      // Execute the query
      const snapshot = await getDocs(searchQuery);

      // Process the results
      snapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      // Get the last document for the next page
      const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;

      return {
        results, // The retrieved results
        lastVisibleDoc: newLastVisibleDoc, // The last document for the next query
      };
    } catch (error) {
      console.error("Error performing global search with pagination:", error);
      throw error;
    }
  }

  async _getBusinessesPaginated(lastVisibleDoc = null, pageSize = 10) {
    const results = [];

    try {
      // Initialize the query to reference the "business" collection
      let businessQuery = query(
        collection(db, "businesses"),
        where("status", "==", "active"), // Reference the collection
        orderBy("updatedAt", "desc"), // Order by 'updatedAt' field in descending order
        limit(pageSize) // Limit the number of results
      );

      // Apply pagination if lastVisibleDoc is provided
      if (lastVisibleDoc) {
        businessQuery = query(businessQuery, startAfter(lastVisibleDoc));
      }

      // Execute the query
      const snapshot = await getDocs(businessQuery);

      // Process the results
      snapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      // Get the last document for the next page
      const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;
      console.log(results);
      return {
        results, // The retrieved businesses
        lastVisibleDoc: newLastVisibleDoc, // The last document for the next query
      };
    } catch (error) {
      console.error("Error retrieving paginated businesses:", error);
      throw error;
    }
  }

  // unsubscribe() {}
  // Start Firebase fucntions.
  _liveListenerForAccount(id) {
    // this.unsubscribe;
    if (id) {
      if (this.#liveListenerForAccount) return;
      const docRef = doc(db, "accounts", id);

      // Set up a live listener
      this.unsubscribe = onSnapshot(
        docRef,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            this.#currentAuthUserData = docSnapshot.data();
          } else {
            console.log("No such document!");
          }
        },
        (error) => {
          console.error("Error listening to document changes:", error);
        }
      );
      this.#liveListenerForAccount = true;
    } else {
      // To stop listening if id is not there
      if (this.unsubscribe) {
        console.log("Was killed");
        this.unsubscribe(); // Unsubscribe only if the unsubscribe function exists
        this.#liveListenerForAccount = false;
      }

      // this.unsubscribe();
    }
  }

  _authStateHandlerOnceAndOnChange() {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('this');
        this._signedInOrOut(true);

        if (!user.devices) {
          // this._initializePushNotifications()
        }

      } else {
        console.log('this');
        // For dev purposes auto login after clearing site data
        // this._signInUser('benklassen19@icloud.com', 'BeOnMercadoMAI2025')
        // this._signInUser('mercadomaionline@gmail.com', 'Be12345')
        this._signedInOrOut();
      }
    });
  }

  _getLatestCurrentUserData(uid) {
    return this.#currentAuthUserData;
  }


  async _signedInOrOut(signedIn = false) {
    try {
      if (!signedIn) {
        if (this.#userDataLiveListenerUnsubscribe) {

          this.#userDataLiveListenerUnsubscribe();

          this.#userDataLiveListenerUnsubscribe = null;
          this.#currentAuthUserData = null;
          location.reload(true); // force reload from server (some browsers ignore this)
        }
        return
      }

      spinner._displaySpinner("Cargando tu cuenta");

      await this._getUserDataFromBase();

    } catch (error) {
      console.log(error);
      spinner._hideSpinner();
      StartUpMainApp._init();
    } finally {
      StartUpMainApp._init();
      CTANotifications._initNotificationClickListener()
      spinner._hideSpinner();
    }
  }

  // async _getUserDataFromBase(uid = this.#currentAuthUserData?.userId, timeoutInMs = 20000) {
  //   if (!uid) {
  //     this.#currentAuthUserData = null;
  //     return null;
  //   }

  //   const docRef = doc(db, "accounts", uid);

  //   return new Promise((resolve) => {
  //     let timeoutId;
  //     let resolved = false;

  //     const unsubscribe = onSnapshot(
  //       docRef,
  //       (docSnapshot) => {
  //         if (docSnapshot.exists()) {
  //           clearTimeout(timeoutId);
  //           unsubscribe();

  //           this.#currentAuthUserData = docSnapshot.data();
  //           resolved = true;
  //           resolve(this.#currentAuthUserData);
  //         }
  //       },
  //       (error) => {
  //         console.error("Error listening to user document:", error);
  //         clearTimeout(timeoutId);
  //         unsubscribe();

  //         this.#currentAuthUserData = null;
  //         resolved = true;
  //         resolve(null);
  //       }
  //     );

  //     timeoutId = setTimeout(() => {
  //       if (!resolved) {
  //         unsubscribe();
  //         this.#currentAuthUserData = null;
  //         resolve(null);
  //       }
  //     }, timeoutInMs);
  //   });
  // }

  // async _getUserDataFromBase(
  //   uid = this.#currentAuthUserData?.userId,
  //   timeoutInMs = 20000
  // ) {

  //   if (!uid) {
  //     this.#currentAuthUserData = null;
  //     return null;
  //   }

  //   const docRef = doc(db, "accounts", uid);

  //   // unsubscribe previous live listener if exists
  //   if (this.#userDataLiveListenerUnsubscribe) {
  //     this.#userDataLiveListenerUnsubscribe();
  //     this.#userDataLiveListenerUnsubscribe = null;
  //   }

  //   return new Promise((resolve) => {

  //     let timeoutId;
  //     let resolved = false;

  //     const unsubscribe = onSnapshot(

  //       docRef,

  //       (docSnapshot) => {

  //         if (docSnapshot.exists()) {

  //           // always keep local data updated live
  //           this.#currentAuthUserData =
  //             docSnapshot.data();

  //           // FIRST successful load only
  //           if (!resolved) {

  //             clearTimeout(timeoutId);

  //             resolved = true;

  //             // save persistent listener
  //             this.#userDataLiveListenerUnsubscribe =
  //               unsubscribe;

  //             resolve(this.#currentAuthUserData);

  //           }

  //         }

  //       },

  //       (error) => {

  //         console.error(
  //           "Error listening to user document:",
  //           error
  //         );

  //         clearTimeout(timeoutId);

  //         unsubscribe();

  //         this.#currentAuthUserData = null;

  //         resolved = true;

  //         resolve(null);

  //       }

  //     );

  //     timeoutId = setTimeout(() => {

  //       if (!resolved) {

  //         unsubscribe();

  //         this.#currentAuthUserData = null;

  //         resolve(null);

  //       }

  //     }, timeoutInMs);

  //   });

  // }


  async _getUserDataFromBase(timeoutInMs = 20000) {

    // get uid directly from authenticated user
    const uid = auth.currentUser?.uid;

    if (!uid) {
      this.#currentAuthUserData = null;
      return null;
    }

    const docRef = doc(db, "accounts", uid);

    // unsubscribe previous live listener if exists
    if (this.#userDataLiveListenerUnsubscribe) {

      this.#userDataLiveListenerUnsubscribe();

      this.#userDataLiveListenerUnsubscribe = null;

    }

    return new Promise((resolve) => {

      let timeoutId;
      let resolved = false;

      const unsubscribe = onSnapshot(

        docRef,

        (docSnapshot) => {

          if (docSnapshot.exists()) {

            // always keep local data updated live
            this.#currentAuthUserData =
              docSnapshot.data();

            // FIRST successful load only
            if (!resolved) {

              clearTimeout(timeoutId);

              resolved = true;

              // save persistent listener
              this.#userDataLiveListenerUnsubscribe =
                unsubscribe;

              resolve(this.#currentAuthUserData);

            }

          }

        },

        (error) => {

          console.error(
            "Error listening to user document:",
            error
          );

          clearTimeout(timeoutId);

          unsubscribe();

          this.#currentAuthUserData = null;

          resolved = true;

          resolve(null);

        }

      );

      timeoutId = setTimeout(() => {

        if (!resolved) {

          unsubscribe();

          this.#currentAuthUserData = null;

          resolve(null);

        }

      }, timeoutInMs);

    });

  }

  async _signOutUser() {
    try {
      await signOut(auth);
      console.log("User signed out successfully.");
    } catch (error) {
      console.error("Error signing out:", error.message);
    }
  }
  async _signInUser(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      console.log("User signed in:", user.uid);
      // location.reload(true); // force reload from server (some browsers ignore this)
      return user.uid;
    } catch (error) {
      throw new Error(error.message);
    }
  }

  // async _authenticateNewUser(email, password) {
  //   try {
  //     const userCredential = await createUserWithEmailAndPassword(
  //       auth,
  //       email,
  //       password
  //     );
  //     const user = userCredential.user;

  //     console.log("User created:", user.uid);

  //     return result
  //     // location.reload(true); // force reload from server (some browsers ignore this)
  //   } catch (error) {
  //     console.error("Error signing up:", error.message);
  //   }
  // }


  async _checkEmailVerificationStatus() {

    try {

      const user = auth.currentUser;

      if (!user) {
        return {
          success: false,
          verified: false,
          message: "No authenticated user"
        };
      }

      // IMPORTANT:
      // Refresh user data from Firebase
      await user.reload();

      // Get refreshed user
      const refreshedUser = auth.currentUser;

      const isVerified = refreshedUser.emailVerified;

      console.log("Email verified:", isVerified);

      return {
        success: true,
        verified: isVerified
      };

    } catch (error) {

      console.error(
        "Error checking email verification:",
        error
      );

      return {
        success: false,
        verified: false,
        errorCode: error.code,
        message: error.message
      };

    }

  }

  async _sendVerificationEmail() {

    try {

      const user = auth.currentUser;

      if (!user) {

        return {
          success: false,
          message: "No authenticated user"
        };

      }

      await sendEmailVerification(user, {
        url: "https://mercadomai.com?verified"
      });

      console.log(
        "Verification email sent successfully"
      );

      return {
        success: true
      };

    } catch (error) {

      console.error(
        "Error sending verification email:",
        error
      );

      return {
        success: false,
        errorCode: error.code,
        message: error.message
      };

    }

  }

  async _sendPasswordResetEmail(email) {

    try {

      if (!email) {

        return {
          success: false,
          message: "No email provided"
        };

      }

      await sendPasswordResetEmail(auth, email, {
        url: "https://mercadomai.com?login"
      });

      console.log(
        "Password reset email sent successfully"
      );

      return {
        success: true
      };

    } catch (error) {

      console.error(
        "Error sending password reset email:",
        error
      );

      return {
        success: false,
        errorCode: error.code,
        message: error.message
      };

    }

  }

  async _authenticateNewUser(email, password) {

    try {

      // Create Auth user
      const userCredential =
        await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

      const user = userCredential.user;

      console.log("User created:", user.uid);

      // Send verification email
      await sendEmailVerification(user, {
        url: "https://mercadomai.com?verified"
      });

      console.log("Verification email sent");

      // OPTIONAL (recommended)
      // Force verification before app usage
      // await signOut(auth);

      return {
        success: true,
        verificationSent: true
      };

    } catch (error) {

      console.error("Error signing up:", error);

      return {
        success: false,
        errorCode: error.code,
        message: error.message
      };
    }
  }

  async _updateUserTemplate(data) {
    const updateUserDataStructure = httpsCallable(
      functions,
      "updateUserDataStructure"
    );
    const result = await updateUserDataStructure(data);
    return result;
  }
  async _uploadNewListing(dataIn) {
    const data = dataIn.listingData;
    let tokens = [];
    tokens.push(data.listingMachineType);
    data.listingBrand.split("-").forEach((spl) => {
      tokens.push(spl);
    });
    data.listingModel.split("-").forEach((spl) => {
      tokens.push(spl);
    });
    tokens.push(data.listingBrand);
    tokens.push(data.listingModel);
    tokens.push(data.listingCondition);
    tokens.push(data.listingYear);

    const generatedTokes = GENRALHELPERS._createTokens(
      data.listingName,
      omittedWordsInTokens
    );

    generatedTokes.forEach((token) => {
      tokens.push(token);
    });

    const dataToUpload = dataIn;
    console.log(dataToUpload);

    dataToUpload.listingData.listingTokens = tokens;
    console.log(data);
    const createListingFree = httpsCallable(functions, "createListingFree");
    const result = await createListingFree(dataToUpload);
    // const createListing = httpsCallable(functions, "createListing");
    // const result = await createListing(dataToUpload);
    return result;
  }


  async _NvUploadNewListing(dataIn) {
    console.log(dataIn);
    const NVCreateListingFree = httpsCallable(functions, "NVCreateListingFree");
    const result = await NVCreateListingFree(dataIn);
    return result;
  }



  async _NVEditBusinessCatLists(dataIn) {
    console.log(dataIn);
    const NVEditBusinessCatLists = httpsCallable(functions, "NVEditBusinessCatLists");
    const result = await NVEditBusinessCatLists(dataIn);
    console.log(result);
    return result;
  }


  async _createUpdateBusiness(data, imgBack, imgProfile, edit) {
    let tokens = [];

    const generatedTokesForName = GENRALHELPERS._createTokens(
      data.name,
      omittedWordsInTokens
    );
    const generatedTokesForDescription = GENRALHELPERS._createTokens(
      data.shortDescription,
      omittedWordsInTokens
    );

    generatedTokesForName.forEach((token) => {
      tokens.push(token);
    });
    generatedTokesForDescription.forEach((token) => {
      tokens.push(token);
    });

    // Prepare data for the new business document
    const businessData = {
      moreData: {
        edit: edit,
      },
      // businessId: businessId,
      name: data.name,
      shortDescription: data.shortDescription,
      backgroundImg: imgBack,
      profileImg: imgProfile,
      about: data.about,
      ratedAt: data.ratedAt,
      numberOfReviews: data.numberOfReviews,
      listingsApear: data.listingsApear,
      place: data.place,
      contacts: data.contacts,
      lists: data.lists,
      colors: data.colors,
      businessTokens: tokens,
      // status: "active",
      // priorityLevelPoints: 100,
      // views: 0,
      // numberOfFollowers: 0,
      // saves: 0,
      // shares: 0,
      // updatedAt: serverTimestamp(),
      // createdAt: serverTimestamp(),
    };
    const createUpdateBusiness = httpsCallable(
      functions,
      "createUpdateBusiness"
    );
    console.log(businessData);
    const result = await createUpdateBusiness(businessData);
    return result;
  }
  async _getOrderDraft(data) {
    try {
      console.log(data);
      const createOrderDraft = httpsCallable(functions, "createOrderDraft");
      const result = await createOrderDraft(data);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _getPaypalOrder() {
    const realdata = {
      draftOrderId: "fvb84ibcn9on439xij4p3",
      useWallet: true,
    };
    const data = {
      amount: "211",
    };
    try {
      console.log(data);
      const paymentHandle = httpsCallable(functions, "paymentHandle");
      const result = await paymentHandle(data);
      console.warn(result);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _activateWallet(data) {
    try {
      console.log(data);
      const createWallet = httpsCallable(functions, "createWallet");
      const result = await createWallet(data);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _requestPayPalOrder(data) {
    try {
      console.log(data);
      const createPayPalOrder = httpsCallable(functions, "createPayPalOrder");
      const result = await createPayPalOrder(data);
      console.log(result);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _requestPaymentOrder(data) {
    try {
      console.log(data);
      const createStripePayment = httpsCallable(
        functions,
        "createStripePayment"
      );
      const result = await createStripePayment(data);
      console.log(result);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _writeVisitStats(activity, data) {
    console.error("No View recorded. IN DEV MODE");
    return;
    console.warn(data);
    try {
      // console.log(data);
      const activitySiteViewUp = httpsCallable(functions, "activitySiteViewUp");
      const result = await activitySiteViewUp(data);
      // const result = "In Dev. Not Updated";
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _processPaymentOnOrder(data) {
    try {
      console.log(data);
      const proccesingPaymentOnOrder = httpsCallable(
        functions,
        "proccesingPaymentOnOrder"
      );
      const result = await proccesingPaymentOnOrder(data);
      console.log(result);
      return result;
    } catch (error) {
      return error;
    }
  }
  async _updateViewsOnListings(data) {
    console.error("No View recorded. IN DEV MODE");
    return;
    // return;
    try {
      console.log(data);
      const updateViewsOnListings = httpsCallable(
        functions,
        "updateViewsOnListings"
      );
      const result = await updateViewsOnListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateViewsOnBusiness(data) {
    // return;
    try {
      console.log(data);
      const updateViewsOnBusiness = httpsCallable(
        functions,
        "updateViewsOnBusiness"
      );
      const result = await updateViewsOnBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateLikesOnListings(data) {
    try {
      console.log(data);
      const updateLikesOnListings = httpsCallable(
        functions,
        "updateLikesOnListings"
      );
      const result = await updateLikesOnListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateSavesOnListings(data) {
    try {
      console.log(data);
      const updateSavesOnListings = httpsCallable(
        functions,
        "updateSavesOnListings"
      );
      const result = await updateSavesOnListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateSharesOnListings(data) {
    try {
      console.log(data);
      const updateSharesOnListings = httpsCallable(
        functions,
        "updateSharesOnListings"
      );
      const result = await updateSharesOnListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateSavesOnBusiness(data) {
    try {
      console.log(data);
      const updateSavesOnBusiness = httpsCallable(
        functions,
        "updateSavesOnBusiness"
      );
      const result = await updateSavesOnBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateFollowsOnBusiness(data) {
    try {
      console.log(data);
      const updateFollowsOnBusiness = httpsCallable(
        functions,
        "updateFollowsOnBusiness"
      );
      const result = await updateFollowsOnBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _updateSharesOnBusiness(data) {
    try {
      console.log(data);
      const updateSharesOnBusiness = httpsCallable(
        functions,
        "updateSharesOnBusiness"
      );
      const result = await updateSharesOnBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _registerPWAInstalls(data) {
    try {
      console.log(data);
      const registerPWAInstalls = httpsCallable(
        functions,
        "registerPWAInstalls"
      );
      const result = await registerPWAInstalls(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _syncDataToItems(data) {
    try {
      console.log(data);
      const syncDataToItems = httpsCallable(functions, "syncDataToItems");
      const result = await syncDataToItems(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _NVDeleteListing(data) {
    console.error(data);
    try {
      console.log(data);
      const NVDeleteListing = httpsCallable(functions, "NVDeleteListing");
      const result = await NVDeleteListing(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _NVDeleteBusiness(data) {
    console.error(data);
    try {
      console.log(data);
      const NVDeleteBusiness = httpsCallable(functions, "NVDeleteBusiness");
      const result = await NVDeleteBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _deleteAccount(data) {
    console.error(data);
    try {
      console.log(data);
      const deleteAccount = httpsCallable(functions, "deleteAccount");
      const result = await deleteAccount(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _generateImgFromHtmlCss(id) {
    function getHtmlAndCss() {
      const element = document.getElementById(id);
      if (!element) return null;

      // Get HTML content
      const html = element.outerHTML;

      // Get all styles from stylesheets
      let css = "";
      for (let sheet of document.styleSheets) {
        try {
          for (let rule of sheet.cssRules) {
            css += rule.cssText + "\n";
          }
        } catch (err) {
          console.warn("Could not read stylesheet:", sheet.href);
        }
      }

      return { html, css };
    }
    const htmlCss = getHtmlAndCss();

    try {
      const generateImgFromHtmlCss = httpsCallable(
        functions,
        "generateImgFromHtmlCss"
      );
      const result = await generateImgFromHtmlCss(htmlCss);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _uploadImagesByUrls(imageUrls) {
    const uploadedURLs = [];

    // Helper: Convert data URL to File
    function dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) u8arr[n] = bstr.charCodeAt(n);
      return new File([u8arr], filename, { type: mime });
    }

    // Helper: Resize image
    function resizeImage(file, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = (e) => (img.src = e.target.result);
        reader.onerror = () => reject(new Error("Failed to read file."));
        reader.readAsDataURL(file);

        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) =>
              blob
                ? resolve(blob)
                : reject(new Error("Failed to resize image.")),
            "image/jpeg",
            0.7
          );
        };

        img.onerror = () => reject(new Error("Failed to load image."));
      });
    }

    // Process each image URL
    for (const imageSrc of imageUrls) {
      try {
        // ✅ If already a Firebase URL, skip uploading
        if (imageSrc.includes("firebasestorage.googleapis.com")) {
          uploadedURLs.push(imageSrc);
          continue;
        }

        // ✅ Only process if it’s a data URL
        if (!imageSrc.startsWith("data:")) {
          console.warn("Skipping non-data URL:", imageSrc);
          continue;
        }

        const imageFile = dataURLtoFile(imageSrc, `${uuidv4()}.jpg`);
        const resizedImage = await resizeImage(imageFile, 800, 800);

        // Upload resized image
        const fileId = `${uuidv4()}.jpg`;
        const storageRef = ref(storage, `images/${fileId}`);
        await uploadBytes(storageRef, resizedImage);
        const downloadURL = await getDownloadURL(storageRef);

        uploadedURLs.push(downloadURL);
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }

    return uploadedURLs;
  }



  async _NVCommentOnTips(data) {
    console.log(data);
    try {
      console.log(data);
      const NVCommentOnTips = httpsCallable(functions, "NVCommentOnTips");
      const result = await NVCommentOnTips(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVDeleteTipComment(data) {
    console.log(data);
    try {
      console.log(data);
      const NVDeleteTipComment = httpsCallable(functions, "NVDeleteTipComment");
      const result = await NVDeleteTipComment(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVSearchListingsFunction(data) {
    console.log(data);
    try {
      console.log(data);
      const searchListings = httpsCallable(functions, "searchListings");
      const result = await searchListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }



  async _NVSearchBusinessesFunction(data) {
    console.log(data);
    try {
      console.log(data);
      const searchBusinesses = httpsCallable(functions, "searchBusinesses");
      const result = await searchBusinesses(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }


  async _NVSearchSellersFunction(data) {
    console.log(data);
    try {
      console.log(data);
      const searchSellers = httpsCallable(functions, "searchSellers");
      const result = await searchSellers(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }



  async _NVcreateUpdateBusiness(data) {
    console.log(data);
    try {
      console.log(data);
      const NVcreateUpdateBusiness = httpsCallable(functions, "NVcreateUpdateBusiness");
      const result = await NVcreateUpdateBusiness(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }


  async _mlItemPreview(data) {
    console.log(data);
    try {
      console.log(data);
      const mlItemPreviewCallable = httpsCallable(functions, "mlItemPreview");
      const result = await mlItemPreviewCallable(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }



  async _NVWUpdateNotiSetBlockedCat(data) {
    console.log(data);
    try {
      console.log(data);
      const NVWUpdateNotiSetBlockedCat = httpsCallable(functions, "NVWUpdateNotiSetBlockedCat");
      const result = await NVWUpdateNotiSetBlockedCat(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVWUpdateDeleteDevice(data) {
    console.log(data);
    try {
      console.log(data);
      const NVWUpdateDeleteDevice = httpsCallable(functions, "NVWUpdateDeleteDevice");
      const result = await NVWUpdateDeleteDevice(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _updateUserEmailVerifiedStatus(data) {
    console.log(data);
    try {
      console.log(data);
      const updateUserEmailVerifiedStatus = httpsCallable(functions, "updateUserEmailVerifiedStatus");
      const result = await updateUserEmailVerifiedStatus(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }


  // START NV Search
  async _NVsearchListings(data) {
    console.log(data);
    try {
      console.log(data);
      const searchListings = httpsCallable(functions, "searchListings");
      const result = await searchListings(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVsearchBusinesses(data) {
    console.log(data);
    try {
      console.log(data);
      const searchBusinesses = httpsCallable(functions, "searchBusinesses");
      const result = await searchBusinesses(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async _NVsearchSellers(data) {
    console.log(data);
    try {
      console.log(data);
      const searchSellers = httpsCallable(functions, "searchSellers");
      const result = await searchSellers(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  async _NVPreviewAffiliatedItem(data) {
    console.log(data);
    try {
      console.log(data);
      const NVPreviewAffiliatedItem = httpsCallable(functions, "NVPreviewAffiliatedItem");
      const result = await NVPreviewAffiliatedItem(data);
      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  // END NV Search


  async _reportAProblem(data) {
    const reportAProblem = httpsCallable(
      functions,
      "reportAProblem"
    );
    const result = await reportAProblem(data);
    return result;
  }



}

export default new FireBaseHelperOwn();
